/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Services
import { filterCampusVirtual, requestGetAllCampus } from "services/general";
import { throwError } from "services/helpers";
import { 
    requestGetSpaceTypes, 
    requestGetUniversityActivities, 
    requestGetUniversitySpaceReasonsForPenalize 
} from "services/resources/universitySpaces/relatedToUniversitySpaceResources";
//#endregion

const useDataRelatedToUniversitySpaceResources = ({
    loadingRequestOfGrid, fatalError
}) => {
    //#region States
    const [campusList, setCampusList] = useState([]);
    const [spaceTypeList, setSpaceTypeList] = useState([]);
    const [universityActivityList, setUniversityActivityList] = useState([]);
    const [reasonsForPenalize, setReasonsForPenalize] = useState([]);
    //#endregion
    //#region Effects
    useEffect(() => {
        loadingRequestOfGrid.show();
        Promise.all([
            fillCampusList(),
            fillSpaceTypeList(),
            fillUniversityActivityList(),
            fillReasonsForPenalize()
        ])
        .catch(fatalError.notify)
        .finally(() => {
            loadingRequestOfGrid.hide();
        });
    }, []);
    //#endregion
    //#region Functions
    async function fillCampusList() {
        const fetchData = await requestGetAllCampus();
        throwError(fetchData);
        setCampusList(filterCampusVirtual(fetchData));
    }
    async function fillUniversityActivityList() {
        const fetchData = await requestGetUniversityActivities();
        throwError(fetchData);
        setUniversityActivityList(fetchData);
    }
    async function fillSpaceTypeList() {
        const fetchData = await requestGetSpaceTypes();
        throwError(fetchData);
        setSpaceTypeList(fetchData);
    }
    async function fillReasonsForPenalize() {
        const fetchData = await requestGetUniversitySpaceReasonsForPenalize();
        throwError(fetchData);
        setReasonsForPenalize(fetchData);
    }
    //#endregion
    return {
        campusList, spaceTypeList,
        universityActivityList,
        reasonsForPenalize
    };
}

export default useDataRelatedToUniversitySpaceResources;